import PageTitle from '../../components/pagetitle/PageTitle'

import Accordion from '../../components/FaqSection/Accordion';
import ServiceSidebar from './sidebar'

import simag from '../../images/service/d.jpg'
import Gimg1 from '../../images/cta-bg.jpg'
import Gimg2 from '../../images/cta-2.jpg'
import Gimg3 from '../../images/cta-2.jpg'
import Gimg4 from '../../images/cta-4.jpg'


const WarehouseManagement = ({ serviceDetails }) => {
    return (
        <>
            <section className={`wpo-breadcumb-area ${serviceDetails.slug}`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={serviceDetails.title} />
            </section>
            <section id='details' className='wpo-service-single-page section-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12 order-lg-2">
                            <div className="service-single-wrap">
                                <h2>{serviceDetails.title}</h2>
                                <div className="title-image">
                                    <img src={simag} alt="" />
                                </div>

                                <p>
                                    Overflow Logistics offers secure storage facilities at all critical destinations in Australia. Our warehouses are among the safest places to store your goods. They are equipped with electronic theft and fire alarms, backed by round-the-clock security. In addition to usual hygiene standards, we provide certificates for constant checks by specialist companies. All goods are adequately protected, allowing them to remain in our warehouse for as long as necessary. Our extensive warehousing and distribution system will pick, pack, store, and distribute consignments anywhere in the region using efficient transport modes. Special warehousing facilities for household goods and personal effects are available at all Overflow Logistics locations.
                                </p>


                                <div className="row fc-gray my-4 pb-3">
                                    <h5>Services Include:</h5>
                                    <ul className="list-unstyled mt-3 fs-6">
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Short and Long-Term Storage
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            CargoLoading and Unloading
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Cargo Labelling and Packing
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Packing and Crating Services
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Cargo Distribution
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Pod Reporting
                                        </li>
                                    </ul>
                                </div>

                                <h3 className="quate">
                                    Efficient warehouse management is the cornerstone of a robust supply chain, ensuring secure storage, accurate inventory control, and timely distribution to meet customer expectations.
                                </h3>

                                <div className="image-gallery">
                                    <h2>Eligibility checklist :</h2>
                                    <ul>
                                        <li><img src={Gimg1} alt="" /></li>
                                        <li><img src={Gimg2} alt="" /></li>
                                        <li><img src={Gimg3} alt="" /></li>
                                        <li><img src={Gimg4} alt="" /></li>
                                    </ul>
                                </div>
                                <Accordion />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 order-lg-1">
                            <ServiceSidebar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WarehouseManagement